import React from "react";
import PropTypes from "prop-types";

const icons = {
  ASC: "arrow_downward",
  DESC: "arrow_upward",
};

const SortIcon = ({ query, name }) => {
  if (query.sortItem !== name) {
    return null;
  }

  const icon = icons[query.sortOrder];
  return <i className="sort-icon material-icons tiny">{icon}</i>;
};
SortIcon.propTypes = {
  query: PropTypes.shape({
    sortItem: PropTypes.string,
    sortOrder: PropTypes.string,
  }),
  name: PropTypes.string,
};

export default function Table({ empty, columns, rows }) {
  const handleSort = (e) => console.log(e);
  const query = {};

  // const headers = columns.map(x => String(x).toUpperCase());
  const headers = columns.map((x) => {
    switch (typeof x) {
      case "function":
        return x();
      case "object":
        return String(x.value);
      default:
        return String(x).toUpperCase();
    }
  });
  const noRows = rows.length === 0;

  const NoRows = (
    <tr>
      <td colSpan={headers.length}>{empty}</td>
    </tr>
  );

  return (
    <div>
      <table className="bordered striped">
        <thead>
          <tr>
            {headers.map((header, i) => {
              return (
                <th className="cursor-pointer" onClick={handleSort} key={i}>
                  <SortIcon query={query} name={"foo"} />
                  &nbsp;{header}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>{noRows ? NoRows : rows}</tbody>
      </table>
    </div>
  );
}

Table.propTypes = {
  empty: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  columns: PropTypes.array,
  rows: PropTypes.node,
};
